import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord, getApiOrderRecord } from 'services/SalesOrdersService'

export const getData = createAsyncThunk('salesOrders/data/getData', async data => {
    const response = await getApiData(data)
    return response.data
})

export const getRecord = createAsyncThunk('salesOrders/data/getRecord', async id => {
    const headerResponse = await getApiRecord(id)
    const detailResponse = await getApiOrderRecord({ sales_order_hdr_id: id })
    const data = {
        ...headerResponse.data,
        order_details: detailResponse.data || [],
    }
    return data
})

const today = new Date()
const pastDate = new Date()
pastDate.setDate(today.getDate() - 7)

export const orderDefaultData = {
    line_no: '',
    sku: '',
    qty_ordered: '',
    notes: '',
}

const recordData = {
    company: '',
    site: '',
    client: '',
    shipment: '',
    customer: '',
    warehouse_id: '',
    order_type: '',
    doc_no: '',
    reference_1: '',
    reference_2: '',
    priority: '3',
    status: '',
    created_date: '',
    closed_date: '',
    carrier: '',
    carrier_service: '',
    tracking: '',
    line_no: '',
    sku: '',
    qty_ordered: '',
    order_details: [],
    consignee_country: 'AU',
    consignee_zip: '',
    consignee_province: '',
    consignee_city: '',
    consignee_address1: '',
    consignee_name: '',
    consignee_mail: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 100,
    query: '',
    selectedTab: 'N',
    orderType: '',
    startDate: pastDate?.toISOString()?.split('T')[0],
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'salesOrders/data',
    initialState: {
        loading: false,
        view: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, state => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, state => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
